import { isMobile as isMobileDevice } from 'react-device-detect';

const MOBILE_MAX_WIDTH = 768;

/**
 * Returns true if the device is mobile.
 *
 * Uses both user agent detection AND viewport width to avoid false positives
 * where desktop browsers are incorrectly detected as mobile.
 *
 * NOT REACTIVE: this returns the mobile state at the moment of the call.
 * The viewport-width branch reads `window.innerWidth` once and is not wired
 * to a resize listener. Callers that store the result (e.g. `HtmlCell.isMobile`
 * in the constructor) keep the value from when they were created. This is
 * intentional: switching between mobile and desktop UIs mid-session is not a
 * supported flow, so a reload is required to swap.
 */
export function isMobileMode(): boolean {
  // SSR / non-DOM environments: never claim mobile, since UA-based detection
  // alone (via react-device-detect) can flip true without a real viewport.
  if (typeof window === 'undefined') return false;
  // Must pass both checks: user agent indicates mobile AND viewport is mobile-sized
  // This prevents desktop browsers with mobile-like user agents from showing mobile UI
  return isMobileDevice && window.innerWidth <= MOBILE_MAX_WIDTH;
}
